export const FETCH_IAP_REQUEST = 'FETCH_IAP_REQUEST';
export const FETCH_IAP_DATA = 'FETCH_IAP_DATA';
export const FETCH_IAP_RESET = 'FETCH_IAP_RESET';
export const FETCH_IAP_REQUEST_ERROR = 'FETCH_IAP_REQUEST_ERROR';
export const FETCH_IAP_GRAPH_DATA = 'FETCH_IAP_GRAPH_DATA';
export const SET_STATIC_WIDZARDS_DATA_IAP = 'SET_STATIC_WIDZARDS_DATA_IAP';
